import React, { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from "react-router-dom"
import axios from 'axios'
import Cookies from 'js-cookie'
import { confirmAlert } from 'react-confirm-alert'
import { baseURL } from '../../helpers/baseURL'

import SidebarMenu from './SidebarMenu'
import "./sidebar.css"
import { FaBars } from "react-icons/fa"
import arrow from "../../../css/img/arrow_down_filter.svg"
import { ModalContext, ModalProvider, ModalRoot } from "react-multi-modal";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../../redux/actions";
import Workspaces from "../../modals/Workspaces/Workspaces";
import circles from "../../../css/img/window-circles.svg"
import { IoSunny, IoMoon } from "react-icons/io5";
import { HiMiniChevronDoubleLeft } from 'react-icons/hi2'

const LOGO_DARK_MODE = "/images/claritick_tm_white.svg"
const LOGO_LIGHT_MODE = "/images/claritick_tm_dark.svg"

const Sidebar = ({ toggleSidebar, isCollapsed, expandSidebar, theme, setTheme }) => {
    const [toggle, setToggle] = useState(false)
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const userDropdownRef = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchUser())
    }, [dispatch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
                setUserDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const Logout = async () => {
        confirmAlert({
            title: 'Are you sure you want to logout?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () =>
                        axios.post(`${baseURL}logout`, {}, {
                            headers: {
                                Authorization: `Bearer ${Cookies.get('access_token')}`
                            }
                        })
                            .catch(error => console.error(error))
                            .finally(() => {
                                localStorage.clear();
                                Cookies.remove('access_token');
                                Cookies.remove('mydev_token');
                                history.push('/');
                            })
                },
                {
                    label: 'No'
                }
            ],
            overlayClassName: "confirm-overlay"
        });
    };

    const user = useSelector(state => state.userReducer.user);
    const userLoading = useSelector(state => state.userReducer.loading);
    const profileImg = user && user.profile_image ? <img src={`${user && user.profile_image}`} alt="" /> : <img src={"/images/avatar.png"} alt="" />;

    const current_workspace = user?.workspaces?.find(
        (workspace) => workspace.id === (user.current_workspace?.id ?? user.current_workspace)
    )

    const showSidebar = Boolean(user?.id || user?.email);

    const showModalWorkspaces = (showModal) => {
        showModal({
            component: Workspaces
        })
    }

    const isDarkTheme = theme === 'dark';

    // While landing→dashboard handoff is waiting on user, keep chrome visible under the overlay.
    if (!showSidebar) {
        return (
            <>
                <button className="btn toggle-sidemenu-mobile" type="button" aria-hidden="true" tabIndex={-1}>
                    <FaBars />
                </button>
                <div className={`sidemenu ${isCollapsed ? 'collapsed' : 'expanded'}`} aria-busy="true">
                    <div className="sidebar-top">
                        <Link className="home-button" to="/dashboard">
                            <img
                                src={isDarkTheme ? LOGO_DARK_MODE : LOGO_LIGHT_MODE}
                                alt="logo"
                                loading="eager"
                                fetchPriority="high"
                                decoding="sync"
                            />
                        </Link>
                        <button className="btn toggle-sidemenu" type="button" onClick={toggleSidebar}>
                            <HiMiniChevronDoubleLeft />
                        </button>
                    </div>
                    <div className="sidebar-main-elements">
                        <div className="sidebar-workspace">
                            <div className="sidebar-workspace-img">
                                <img src={circles} alt="" />
                            </div>
                            <div className="workspace-info">
                                <h4>
                                    <span className="sidebar-workspace-skeleton skeleton-loading" aria-hidden="true" />
                                </h4>
                            </div>
                        </div>
                        <div className="sidebar-item-list">
                            <div className="sidebar-menu-title">TICKET MANAGEMENT</div>
                            <div className="sidebar-menu-skeleton" aria-hidden="true">
                                <div className="skeleton-loading" style={{ height: 36, marginBottom: 8, borderRadius: 8 }} />
                                <div className="skeleton-loading" style={{ height: 36, marginBottom: 8, borderRadius: 8 }} />
                                <div className="skeleton-loading" style={{ height: 36, marginBottom: 8, borderRadius: 8 }} />
                                <div className="skeleton-loading" style={{ height: 36, borderRadius: 8 }} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const workspaceName = current_workspace?.name;
    const workspaceTitle = current_workspace?.title;
    const workspacePending = userLoading && !workspaceName;

    return (
        <>
            <button className="btn toggle-sidemenu-mobile" onClick={() => setToggle(!toggle)}>
                <FaBars />
            </button>
            <div className={`sidemenu ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="sidebar-top">
                    <Link
                        className='home-button'
                        to="/dashboard"
                        onClick={(e) => {
                            if (isCollapsed) {
                                e.preventDefault();
                                expandSidebar();
                            }
                        }}
                    >
                        <img
                            src={isDarkTheme ? LOGO_DARK_MODE : LOGO_LIGHT_MODE}
                            alt="logo"
                            loading="eager"
                            fetchPriority="high"
                            decoding="sync"
                        />
                    </Link>
                    <button className='btn toggle-sidemenu' onClick={toggleSidebar}><HiMiniChevronDoubleLeft /></button>
                </div>
                <div className={`sidebar-main-elements ${toggle ? 'active' : ''}`}>
                    <div className="sidebar-workspace">
                        <div className="sidebar-workspace-img">
                            <img src={circles} alt="window" />
                        </div>
                        <ModalProvider>
                            <ModalContext.Consumer>
                                {({ showModal, hideModal }) => (
                                    <>
                                        <div className="workspace-info" onClick={() => showModalWorkspaces(showModal)}>
                                            <h4>
                                                {workspaceName || (
                                                    workspacePending
                                                        ? <span className="sidebar-workspace-skeleton skeleton-loading" aria-hidden="true" />
                                                        : null
                                                )}
                                            </h4>
                                            {workspaceTitle ? <span>{workspaceTitle}</span> : null}
                                        </div>
                                        <ModalRoot />
                                    </>
                                )}
                            </ModalContext.Consumer>
                        </ModalProvider>
                    </div>
                    <div className="sidebar-item-list">
                        <div className="sidebar-menu-title">TICKET MANAGEMENT</div>
                        <SidebarMenu isCollapsed={isCollapsed} expandSidebar={expandSidebar} />
                    </div>

                    <div className="sidebar-userbar-wrapper" ref={userDropdownRef}>
                        {userDropdownOpen && (
                            <div className="sidebar-user-dropdown">
                                <Link
                                    className="sidebar-user-dropdown-header"
                                    to="/profile"
                                    onClick={() => setUserDropdownOpen(false)}
                                >
                                    <div className="sidebar-user-dropdown-avatar">
                                        {profileImg}
                                    </div>
                                    <div className="sidebar-user-dropdown-info">
                                        <div className="sidebar-user-dropdown-name">{user?.name}</div>
                                        <div className="sidebar-user-dropdown-email">{user?.email || ""}</div>
                                    </div>
                                </Link>

                                <Link
                                    className="sidebar-user-dropdown-item"
                                    to="/developer/docs"
                                    onClick={() => setUserDropdownOpen(false)}
                                >
                                    <span>Documentation</span>
                                </Link>

                                <a
                                    className="sidebar-user-dropdown-item"
                                    href="https://kore.co/contact"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setUserDropdownOpen(false)}
                                    >
                                    <span>Support</span>
                                </a>

                                <div className="sidebar-user-dropdown-appearance">
                                    <div className="sidebar-user-dropdown-appearance-label">Appearance</div>

                                    <div className="sidebar-appearance-frame">
                                        <button
                                            type="button"
                                            className={`sidebar-appearance-segment sun ${theme === "light" ? "active" : ""}`}
                                            onClick={() => theme !== "light" && setTheme("light")}
                                        >
                                            <IoSunny />
                                        </button>

                                        <button
                                            type="button"
                                            className={`sidebar-appearance-segment moon ${theme === "dark" ? "active" : ""}`}
                                            onClick={() => theme !== "dark" && setTheme("dark")}
                                        >
                                            <IoMoon />
                                        </button>
                                    </div>
                                </div>

                                <div className="sidebar-user-dropdown-divider"></div>

                                <button
                                    type="button"
                                    className="sidebar-user-dropdown-item sidebar-user-dropdown-logout"
                                    onClick={Logout}
                                >
                                    {/* <img src={logout} alt="logout" /> */}
                                    <span>Logout</span>
                                </button>
                            </div>
                        )}

                        <button
                            type="button"
                            className="sidebar-userbar"
                            onClick={() => {
                                if (isCollapsed) {
                                    expandSidebar();
                                    setUserDropdownOpen(true);
                                } else {
                                    setUserDropdownOpen(prev => !prev)
                                }
                            }}
                        >
                            <div className="sidebar-userbar-left">
                                <div className="sidebar-userbar-avatar">
                                    {profileImg}
                                </div>

                                <div className="sidebar-userbar-info">
                                    <div className="sidebar-userbar-name">{user?.name}</div>
                                    <div className="sidebar-userbar-email">{user?.email || ""}</div>
                                </div>
                            </div>

                            <span className="sidebar-userbar-menu" aria-hidden="true">
                                •••
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Sidebar;
